import { ExclamationIcon } from "@heroicons/react/outline";
import Button from "components/Button";

type AlertSeverity = "warning" | "critical";

interface UsageAlertProps {
  severity: AlertSeverity;
  message: string;
  showUpgradeButton?: boolean;
  upgradeText?: string;
  onUpgradeClick?: () => void;
}

export default function UsageAlert({
  severity,
  message,
  showUpgradeButton = true,
  upgradeText = "UPGRADE NOW",
  onUpgradeClick,
}: UsageAlertProps) {
  // Determine styling based on severity
  const bgColor =
    severity === "critical"
      ? "bg-red-50"
      : "bg-yellow-50";

  const borderColor =
    severity === "critical"
      ? "border-red-200"
      : "border-yellow-200";

  const textColor =
    severity === "critical"
      ? "text-red-800"
      : "text-yellow-800";

  const iconColor =
    severity === "critical"
      ? "text-red-600"
      : "text-yellow-600";

  return (
    <div
      className={`flex items-start gap-3 p-4 border rounded-lg ${bgColor} ${borderColor}`}
    >
      <ExclamationIcon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconColor}`} />
      <div className="flex-1 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className={`text-sm font-medium ${textColor}`}>{message}</p>
        {showUpgradeButton && onUpgradeClick && (
          <Button
            text={upgradeText}
            onClick={onUpgradeClick}
            className="button button-primary flex-shrink-0"
            size="SM"
          />
        )}
      </div>
    </div>
  );
}
